export default "__VITE_ASSET__978b56a8__"